import { createFileRoute } from "@tanstack/react-router";
import { AgentSkillsCreateRoute } from "@/components/agents/agent-skills-route";

export const Route = createFileRoute("/$owner/agents/$agentId/skills/create")({
	component: AgentSkillsCreatePage,
});

function AgentSkillsCreatePage() {
	const { owner, agentId } = Route.useParams();
	return <AgentSkillsCreateRoute owner={owner} agentId={agentId} />;
}